export default __webpack_public_path__ + "static/media/Spotify3.d7459f72.png";